import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  CustomInputTextArea,
  CustomModal,
  CustomTabView,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
} from '../../../../components'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { TabPanel } from 'primereact/tabview'
import InputCnpjCpf from '../../../../components/InputCnpjCpf/InputCnpjCpf'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Alterando carregamento',
  SUCCESS: 'Carregamento alterado com sucesso',
}

function formatDate(dateStr) {
  if (!dateStr) return ''
  if (/^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2})?$/.test(String(dateStr))) return dateStr
  const s = String(dateStr).split('T')
  const d = s[0].split('-')
  if (d.length === 3) {
    const [ano, mes, dia] = d
    return `${dia}/${mes}/${ano}`
  }
  return ''
}

const INITIAL_STATE = {
  entrega: {
    client_id: 0,
    delivery_id: 0,
    identifier: '',
    nome_fantasia: '',
    cnpj: '',
    company_name: '',
    city: '',
    qte_sku: 0,
    weight: 0,
    razao_social: '',
    district: '',
    step_id: 0,
    picking_id: 0,
    status_id: 0,
    motivo_atraso: null,
    event_id: 0,
    observation: '',
    cycle_id: null,
    cycle_name: '',
    cycle_data_operacao: null,
    cycle_deadline: null,
    data_entrada: '',
    primeira_data_agendamento: '',
    proxima_data_agendamento: '',
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  activeTab: 0,
}

function ModalEditarCarregamento({ data, show, onModalClose, onModalSave, dispatch }) {
  // Hooks
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (data) {
      setState(prevState => {
        prevState.entrega = data
        return { ...prevState }
      })
    }
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        alterarEntrega(state.entrega)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.entrega)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const alterarEntrega = entrega => {
    const updatedDelivery = {
      id: entrega.delivery_id,
      observation: entrega.observation,
    }
    DeliveryHttp.updateDelivery(updatedDelivery)
      .then(() => {
        setState(prevState => {
          prevState.loadingMessage = LOAD_MESSAGE.SUCCESS
          return { ...prevState }
        })
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  // Events
  const onBtnSalvarClicked = () => {
    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
  }

  const onTabChange = value => {
    setState(prevState => ({ ...prevState, activeTab: value }))
  }

  // Render
  return (
    <CustomModal
      header="Entregas por Empresa - Detalhes"
      isVisible={show}
      width={850}
      onClose={onModalClose}
    >
      <CustomTabView activeIndex={state.activeTab} onTabChange={onTabChange}>
        <TabPanel header={'Detalhes'}>
          <div className="p-grid">
            <div className="p-col-4">
              <InputText label={'Identificador'} disabled value={state.entrega.identifier} />
            </div>
            <div className="p-col-4">
              <InputText label={'Nome Fantasia'} disabled value={state.entrega.nome_fantasia} />
            </div>
            <div className="p-col-4">
              <InputCnpjCpf
                label={'CNPJ/CPF'}
                disabled
                value={state.entrega.cnpj}
                onChange={() => {}}
              />
            </div>
            <div className="p-col-4">
              <InputText label={'Empresa'} disabled value={state.entrega.company_name} />
            </div>
            <div className="p-col-4">
              <InputText label={'Bairro'} disabled value={state.entrega.district} />
            </div>
            <div className="p-col-4">
              <InputText label={'Cidade'} disabled value={state.entrega.city} />
            </div>
            <div className="p-col-4">
              <InputNumeroInteiro
                label={'Qte. SKUs'}
                disabled
                value={state.entrega.qte_sku}
                onChange={() => {}}
              />
            </div>
            <div className="p-col-4">
              <InputNumeroDecimal
                label={'Peso'}
                disabled
                value={state.entrega.weight}
                onChange={() => {}}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Data de Entrada'}
                disabled
                value={formatDate(state.entrega.data_entrada || state.entrega.created_at)}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Ciclo'}
                disabled
                value={
                  state.entrega.cycle_id
                    ? `${state.entrega.cycle_id} - ${state.entrega.cycle_name || ''}`
                    : ''
                }
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Ciclo - Data da Operação'}
                disabled
                value={formatDate(state.entrega.cycle_data_operacao)}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Ciclo - Deadline'}
                disabled
                value={formatDate(state.entrega.cycle_deadline)}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Primeira Data Agendamento'}
                disabled
                value={formatDate(state.entrega.primeira_data_agendamento)}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Próxima Data Agendamento'}
                disabled
                value={formatDate(state.entrega.proxima_data_agendamento)}
              />
            </div>
            <div className="p-col-4">
              <InputText
                label={'Motivo Atraso'}
                disabled
                value={state.entrega.motivo_atraso || ''}
              />
            </div>
          </div>
        </TabPanel>
        <TabPanel header={'Observações'}>
          <form className="p-grid">
            <div className="p-col-12">
              <CustomInputTextArea
                label={'Observações'}
                onChange={observation => {
                  setState(prevState => {
                    prevState.entrega.observation = observation
                    return { ...prevState }
                  })
                }}
                value={state.entrega.observation || ''}
                rows={4}
              />
            </div>
            <div className="p-col-12">
              <Btn onClick={() => onBtnSalvarClicked(state)}>Salvar</Btn>
            </div>
          </form>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}
export default connect()(ModalEditarCarregamento)
